export default __webpack_public_path__ + "static/media/qatar_Airways.4845b9de.png";